export enum PolygonType {
    FLAT,
    /** Polygon rendered as 3D shape. Based on a set of two polygons (side layer and top layer). */
    BLOCK
}
export enum PolygonType {
    FLAT,
    /** Polygon rendered as 3D shape. Based on a set of two polygons (side layer and top layer). */
    BLOCK
}
